import React from 'react';
import { Link } from 'react-router-dom';
import Project1 from '../../assets/images/projects/projects-1.jpg'
import Project2 from '../../assets/images/projects/projects-2.jpg'
import Project3 from '../../assets/images/projects/projects-3.jpg'
import Project4 from '../../assets/images/projects/projects-4.jpg'
import Project5 from '../../assets/images/projects/projects-5.jpg'
import Project6 from '../../assets/images/projects/projects-6.jpg'
import Project7 from '../../assets/images/projects/projects-7.jpg'
import Project8 from '../../assets/images/projects/projects-8.jpg'


function ProjectPage() {
  return (
    <div>
      <section className="projects-page">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <img
                    src={Project1}
                    alt="projects-1"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <span>Product Sale</span>
                  <h3>
                    <Link to="/project-details">
                      How To Grow sale &amp; product marketing
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <img
                    src={Project2}
                    alt="projects-2"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="400ms"
                >
                  <span>Marketing</span>
                  <h3>
                    <Link to="/project-details">
                      Increase 2x Faster SEO Strategy Develop
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <img
                    src={Project3}
                    alt="projects-3"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <span>Product Sale</span>
                  <h3>
                    <Link to="/project-details">
                      How To build lead generations
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <img
                    src={Project4}
                    alt="projects-4"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="400ms"
                >
                  <span>Marketing</span>
                  <h3>
                    <Link to="/project-details">
                      Paid Social Media Marketing Strategy
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <img
                    src={Project5}
                    alt="projects-5"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <span>SEO Optimization</span>
                  <h3>
                    <Link to="/project-details">
                      User Research &amp; SEO Optimizations
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <img
                    src={Project6}
                    alt="projects-6"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="400ms"
                >
                  <span>Marketing</span>
                  <h3>
                    <Link to="/project-details">
                      Development your Digital marketing
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <img
                    src={Project7}
                    alt="projects-7"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <span>Product Sale</span>
                  <h3>
                    <Link to="/project-details">
                      Grow your Project manager pointing
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="projects-single-box">
                <div
                  className="projects-single-img wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <img
                    src={Project8}
                    alt="projects-8"
                  />
                </div>
                <div
                  className="projects-single-detail wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="400ms"
                >
                  <span>Marketing</span>
                  <h3>
                    <Link to="/project-details">
                      Increase 2x Faster SEO Strategy Develop
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div
            className="projects-view-more-btn text-center wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
          >
            <Link to="/projects" className="main-black-btn thm-btn">
              View More Project <i className="icon-right-arrow" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ProjectPage
